import { render, staticRenderFns } from "./currencyInput.vue?vue&type=template&id=5483d33f&"
import script from "./currencyInput.vue?vue&type=script&lang=js&"
export * from "./currencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports